import { bindActionCreators } from 'redux';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchGroup } from 'focus_groups/ducks/view_state';
import partial from 'lodash/partial';

import View from 'focus_groups/components/view';

export function mapStateToProps(state) {
  const viewState = idx(state, _ => _.project.focusGroups.viewState);
  const isVoting = idx(state, _ => _.project.focusGroups.vote.isVoting);

  return { viewState, isVoting };
}

export function mapDispatchToProps(dispatch, { params }) {
  const { focusGroupId, participantKey } = params;

  return bindActionCreators({
    fetch: partial(fetchGroup, focusGroupId, participantKey),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(View));



// WEBPACK FOOTER //
// ./focus_groups/containers/view.js